import React, { PureComponent } from "react";
import { Form, Button, notification } from "antd";
import _ from "lodash";
import { withRedux } from "../../hoc";
import { logoutAction } from "../../actions/auth";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {
  logoutAction
};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class LogoutForm extends PureComponent {
  logout = () => {
    const { t } = this.props;
    this.props.actions.logoutAction();
    notification.success({
      message: t("Logout Success")
    });
    this.props.onLogout();
  };
  handleSubmitLogout = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.logout();
      }
    });
  };
  render() {
    const { t } = this.props;
    return (
      <Form onSubmit={this.handleSubmitLogout}>
        <Form.Item style={{ textAlign: "center" }}>
          <span className="ant-form-text">{t("You can log out from your account here")}</span>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button type="primary" htmlType="submit" className="log-out-form-button">
            {t("Log-out")}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/LogoutForm.js